import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { tableId: String };

  toggle(event) {
    const table = document.getElementById(this.tableIdValue);
    if (!table) return;

    const key = event.target.dataset.columnKey;
    table.querySelectorAll(`[data-column-key="${key}"]`).forEach((el) => {
      el.classList.toggle("hidden", !event.target.checked);
    });
  }
}
